<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  image: props.data?.image || "",
    countrys_id: props.data?.countrys_id || "",
    lat: props.data?.lat || "",
    lng: props.data?.lng || "",
    name: props.data?.name || props.listCreateName || "",
    code: props.data?.code || "",
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

setFieldRules("countrys_id", [required("Building is required")]);
setFieldRules("code", [required("Code is required")]);
setFieldRules("name", [required("Name is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          label="Image"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="brands"
          v-model="fields.image.value"
        />
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <TextInput
          v-model="fields.code.value"
          label="Code"
          :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null"
          @blur="fields.code.touched = true"
        />

        <TextInput
          v-model="fields.name.value"
          label="Name"
          placeholder="Enter Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />

        <SearchSelect
          v-model="fields.countrys_id.value"
          label="Country"
          end-point="system/master-data/countrys"
          :allowNewRecord="true"
          :readonly="isReadOnly"
          :error="fields.countrys_id.touched ? fields.countrys_id.error : null"
          @blur="fields.countrys_id.touched = true"
        />

        <NumberInput
          v-model="fields.lat.value"
          label="Latitude"
          :readonly="isReadOnly"
          :min="0"
          :error="fields.lat.touched ? fields.lat.error : null"
          @blur="fields.lat.touched = true"
        />

        <NumberInput
          v-model="fields.lng.value"
          label="Longitude"
          :readonly="isReadOnly"
          :min="0"
          :error="fields.lng.touched ? fields.lng.error : null"
          @blur="fields.lng.touched = true"
        />

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>